import { getToken, getCurrentUser } from '@/utilities/token';

export const authGuard = (to) => {
  const requiresAuth = to.matched.some(record => record.meta?.requiresAuth);
  const token = getToken();

  if (requiresAuth && !token) {
    return {
      name: 'login',
      query: { redirect: to.fullPath }
    };
  }

  if ((to.name === 'login' || to.name === 'register' || to.name === 'forgot-password' || to.name === 'reset-password' || to.name === 'confirm-account' || to.name === 'unlock-account') && token) {
    const currentUser = getCurrentUser();
    return {
      name: currentUser?.role === 'admin' ? 'manage-users' : 'reports'
    };
  }
};

export const adminGuard = (to) => {
  const requiresAdmin = to.matched.some(record => record.meta?.requiresAdmin);

  if (requiresAdmin) {
    const currentUser = getCurrentUser();

    if (!currentUser || currentUser.role !== 'admin') {
      return {
        name: 'not-found'
      };
    }
  }
};
